export default "__VITE_ASSET__DELqPEc6__"